/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'preferences': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zM106 82.761V69.236l-6.773-.742a24.561 24.561 0 0 0-1.496-3.607l4.267-5.32-9.565-9.563-5.318 4.267a24.136 24.136 0 0 0-3.616-1.5L82.763 46H69.237l-.734 6.77c-1.255.404-2.465.91-3.623 1.504l-5.31-4.27-9.566 9.565 4.273 5.31a24.514 24.514 0 0 0-1.506 3.623L46 69.236v13.525l6.77.734a24.23 24.23 0 0 0 1.504 3.623l-4.27 5.313 9.563 9.565 5.31-4.273a24.136 24.136 0 0 0 3.616 1.501l.744 6.776h13.526l.741-6.773a24.299 24.299 0 0 0 3.608-1.498l5.32 4.267 9.563-9.565-4.267-5.318a24.304 24.304 0 0 0 1.498-3.608l6.774-.744zM76 93c-9.388 0-17-7.612-17-17s7.612-17 17-17 17 7.612 17 17-7.612 17-17 17z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
